module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://microfrontend-remote-example.web.app/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if (typeof microfrontend_remote_example !== 'undefined') return resolve();
    __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof microfrontend_remote_example !== 'undefined') return resolve();
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        reject(__webpack_error__);
      },
      "microfrontend_remote_example",
    );
  }).then(function () {
    const proxy = {
      get: microfrontend_remote_example.get,
      init: function(shareScope) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          microfrontend_remote_example.init(new Proxy(shareScope, handler))
        } catch (e) {

        }
        microfrontend_remote_example.__initialized = true
      }
    }
    if (!microfrontend_remote_example.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });